import * as types from '../constants';

export function loadFilters() {
  return {
    type: types.LOAD_FILTERS,
  };
}

export function resetSpecificFilter() {
  return {
    type: types.RESET_SPECIFIC_FILTER,
  };
}

export function loadSpecificFilter(name, dataType) {
  return {
    type: types.LOAD_SPECIFIC_FILTER,
    name,
    dataType,
  };
}

export function resetTagOptions() {
  return {
    type: types.RESET_TAG_OPTIONS,
  };
}

export function loadTagOptions() {
  return {
    type: types.LOAD_TAG_OPTIONS,
  };
}

export function autoCompleteTagOptions(tagName) {
  return {
    type: types.AUTO_COMPLETE_TAG_OPTIONS,
    tagName,
  };
}

export function toggleFilterSidebar(open) {
  return {
    type: types.TOGGLE_FILTER_SIDEBAR,
    open,
  };
}

export function closeFilterSidebar(open) {
  return {
    type: types.CLOSE_FILTER_SIDEBAR,
    open,
  };
}

export function toggleLeftMenu() {
  return {
    type: types.TOGGLE_LEFT_MENU_SIDEBAR,
  };
}

export function openCreateNewAdvancedFilter() {
  return {
    type: types.OPEN_CREATE_NEW_SIDEBAR,
  };
}

export function openEditAdvancedFilter() {
  return {
    type: types.OPEN_EDIT_SIDEBAR,
  };
}

export function loadFilterProfiles() {
  return {
    type: types.LOAD_FILTER_PROFILES,
  };
}

export function changeFilterProfileScope(filterProfile, scope) {
  return {
    type: types.CHANGE_FILTER_PROFILE_SCOPE,
    scope,
    filterProfile,
  };
}

export function changeFilterProfileName(uuid, name) {
  return {
    type: types.CHANGE_FILTER_PROFILE_NAME,
    uuid,
    name,
  };
}

export function changeSelectedFilterProfile(data) {
  return {
    type: types.CHANGE_SELECTED_FILTER_PROFILE,
    data,
  };
}

export function resetSelectedFilterProfile(data) {
  return {
    type: types.RESET_SELECTED_FILTER_PROFILE,
    data,
  };
}

export function setOriginalFilterProfiles(data) {
  return {
    type: types.SET_ORIGINAL_FILTER_PROFILES,
    data,
  };
}

export function saveFilterProfileLocally(data, shouldApply) {
  return {
    type: types.SAVE_FILTER_PROFILE_LOCALLY,
    data,
    shouldApply,
  };
}

export function saveFilterProfile(data, shouldApply) {
  return {
    type: types.SAVE_FILTER_PROFILE,
    data,
    shouldApply,
  };
}

export function updateFilterProfile(data, shouldApply) {
  return {
    type: types.UPDATE_FILTER_PROFILE,
    data,
    shouldApply,
  };
}

export function clearFilterProfile() {
  return {
    type: types.CLEAR_FILTER_PROFILE,
  };
}

export function applyFilters(uuid) {
  return {
    type: types.APPLY_FILTERS,
    uuid,
  };
}

export function deleteFilterProfile(uuid) {
  return {
    type: types.DELETE_FILTER_PROFILE,
    uuid,
  };
}
